import React from "react"

import * as s from "../Form.module.scss"

import type { Props } from "./CheckBox.interface"

import Tick from "../../../../assets/icons/tick.inline.svg"

export const CheckBox = ({
  id,
  label,
  value,
  onChange,
  error,
  className,
  hideLabel
}: Props) => {
  return (
    <div
      className={`${error && s.CheckBox___errored} ${className && className}`}
      onClick={() => onChange && onChange(!value)}
      onKeyDown={e => e.key === "Enter" && onChange && onChange(!value)}
      role="checkbox"
      tabIndex={0}
      aria-checked={Boolean(Boolean(value))}
    >
      <label htmlFor={id} className="visuallyHidden">{label}</label>
      <div className={s.CheckBox__inner}>
        <div 
        id={id}
          className={`${s.CheckBox__box} ${
            value === true && s.CheckBox__box___active
          }`}
        >
          <Tick />
        </div>
        <span className={hideLabel ? 'visuallyHidden' : ''}>{label}</span>
      </div>
    </div>
  )
}
